// extracted by mini-css-extract-plugin
export default {"card":"formcard_card__s4i6y","compact":"formcard_compact__6PQdd"};